import React, { useEffect, FC, useState } from "react";
import { Table, Button, Input, Tooltip, Checkbox } from "antd";
import { YHModal } from "@/components/YHModal";
import { useSaleSoDetailModel, IMaterialDetailModel } from "./saleSoDetailModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { YhBut } from "@/components/YhButton";
import { formatNum, formatIntPoint, formatIntPoint1 } from "@/utils/utils";
import { ISalesTypeEnum, IPriceTypeEnum } from "@/types/ScmEnums";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
import { maintenanceService } from '../../../../maintenance/maintenanceService'

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddGoodsModal: FC<RouterParamType> = ({ id, mode, parentInfo }) => {
    const { shopAndOrg: { shopId }, user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const { addModalVisible: visible,
        workDataSource,
        workPgCfg,
        addDataSource,
        searchWorkData,
        initPgCfg,
        detailAddForm,
        detailEditForm,
        setWorkDataSource,
        resetWorkloadData,
        setSearchWorkData, setAddDataSource, transformsToPoDetailList, workloadData, setAddModalVisible, } = useSaleSoDetailModel();
    useEffect(() => {
        visible && workloadData(initPgCfg, { age: 1 })
    }, [visible])
    const [checked, setChecked] = useState(true);
    const [minPrice, setMinPrice] = useState('')
    const [maxPrice, setMaxPrice] = useState('')
    const [isHovered, setIsHovered] = useState(false);

    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IMaterialDetailModel[]>([]);
    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: IMaterialDetailModel) => <YhTootip text={text} onClick={() => { handleMouseOver(record) }} />,
            //render: (text: any,record:IMaterialDetailModel) => <YhTootip text={text} onMouseOver={()=>{handleMouseOver(record)}}  onMouseLeave={()=>{handleMouseLeave()}}/>,

        }, {
            title: '商品名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any, record: IMaterialDetailModel) => <YhTootip text={text} onClick={() => { handleMouseOver(record) }} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'availableStock',
        }, {
            title: '库房',
            width: 140,
            dataIndex: 'warehouseName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: true,
        }, {
            title: '价格',
            width: 100,
            dataIndex: 'price',
            editable: true,
        }, {
            title: '总计',
            width: 100,
            dataIndex: 'amount',

        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            // className: "td-wrap",
            render: (text: string, record: IMaterialDetailModel) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"

                    click={() => add(record)}
                    disabled={!!addDataSource.find(item => item.id === record.id) || (record.availableStock === 0 && !!!parentInfo)}
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];

    const onRow = (record: IMaterialDetailModel) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([record]);
        }
        let { customerCode } = mode === "add" ? detailAddForm : detailEditForm;
        let { materialCode, } = record as { materialCode: string }
        let data = {
            customerCode,
            shopId,
            materialCode
        }
        maintenanceService.price(data).then(res => {
            let { retData } = res
            let max = (retData as any).maxPrice.toFixed(2)
            let min = (retData as any).minPrice.toFixed(2)
            setMaxPrice(max)
            setMinPrice(min)
        })
    };
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "sale", "roleCodes": roles };
        return getRoleColumns("sale", "新增商品", newSelectColumns(optType), params);
    };

    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, price, availableStock, purchasePrice, latestPurPrice } = row
        // let newPurPrice = latestPurPrice !== 0 ? latestPurPrice : purchasePrice
        // price = +formatIntPoint1(price, newPurPrice, `修改价格不应小于进货价${newPurPrice}`);
        num = parentInfo ? +formatIntPoint(num) : +formatIntPoint(num, availableStock, "销售数量>可用库存数量")
        price = +formatNum(price);

        let newRow = {
            ...row,
            num,
            price,
            amount: +formatNum(num * price)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, price, availableStock, purchasePrice, latestPurPrice } = row
        // let newPurPrice = latestPurPrice !== 0 ? latestPurPrice : purchasePrice
        // price = +formatIntPoint1(price, newPurPrice, `修改价格不应小于进货价${newPurPrice}`);
        num = parentInfo ? +formatIntPoint(num) : +formatIntPoint(num, availableStock, "销售数量>可用库存数量")
        price = +formatIntPoint(price);

        let newRow = {
            ...row,
            num,
            price,
            amount: +formatNum(num * price)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }

    //销售类型为正常销售 ?配件明细的价格根据售价选择来决定 : 否则取采购进货价
    const add = async (record: IMaterialDetailModel) => {
        let { priceTypeCode, salesTypeCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;
        let { latestPurPrice, materialCode, lateSalePrice, purchasePrice, retailPrice, petroleumPrice, num, ...params } = record as { latestPurPrice: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, petroleumPrice: number }
        let newPrice: number = latestPurPrice ?? purchasePrice;
        if (salesTypeCode === ISalesTypeEnum.NORMAL_SALES) {
            switch (priceTypeCode) {
                //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                case IPriceTypeEnum.CUSTOMER_LATEST:
                    let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                    newPrice = +price;
                    break;
                //售价选择 最近销价 
                case IPriceTypeEnum.RECENT:
                    newPrice = lateSalePrice ?? retailPrice;
                    break;
                //售价选择 零售价
                case IPriceTypeEnum.RETAIL:
                    newPrice = retailPrice;
                    break;
                //售价选择 采购成本价
                case IPriceTypeEnum.PUR_COST:
                    newPrice = latestPurPrice ?? purchasePrice;
                    break;
                //售价选择 档案进价
                case IPriceTypeEnum.BUYING_PRICE:
                    newPrice = purchasePrice ?? latestPurPrice;
                    break;
                //售价选择 石油价格
                case IPriceTypeEnum.PETROLEUM:
                    newPrice = petroleumPrice ?? purchasePrice;
                    break;
            }
        }
        setAddDataSource(origin => [...origin, {
            ...record,
            num,
            price: newPrice,
            amount: +formatNum(num * newPrice)
        }])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id !== record.id)
        setAddDataSource(filterAddDataSource)
    }
    const onOK = async () => {
        transformsToPoDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([]);
        // resetWorkloadData();
        setChecked(true)

    };

    const handleMouseOver = (record: IMaterialDetailModel) => {
        setIsHovered(true);
        let { customerCode } = mode === "add" ? detailAddForm : detailEditForm;
        let { materialCode, } = record as { materialCode: string }
        let data = {
            customerCode,
            shopId,
            materialCode
        }
        maintenanceService.price(data).then(res => {
            let { retData } = res
            let max = (retData as any).maxPrice.toFixed(2)
            let min = (retData as any).minPrice.toFixed(2)
            setMaxPrice(max)
            setMinPrice(min)
        })
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            onBlur={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value?.trim() }) }}
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder="商品编码"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value }) }}
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder="商品名称"
        />
        <Checkbox checked={checked} onChange={(e) => { setChecked(e.target.checked); workloadData(initPgCfg, { ...searchWorkData, age: e.target.checked ? 1 : 0 }); setSearchWorkData({ ...searchWorkData, age: e.target.checked ? 1 : 0 }) }}>
            是否有库存
        </Checkbox>
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">检索</Button>
        <Button onClick={() => { resetWorkloadData(); setChecked(false) }} shape="round">重置</Button>
    </div>

    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        title=""
        width={'70%'}
        bodyHeight={710}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workDataSource}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize }, { ...searchWorkData, age: checked ? 1 : 0 });
                    }
                }}
                onRow={record => ({
                    onClick: () => onRow(record),
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={[...addDataSource]}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={false}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                                setSelectedRowKeys([]);
                            } else {
                                setSelectedRowKeys([record.key]);
                            }
                            let { customerCode } = mode === "add" ? detailAddForm : detailEditForm;
                            let { materialCode, } = record as { materialCode: string }
                            let data = {
                                customerCode,
                                shopId,
                                materialCode
                            }
                            maintenanceService.price(data).then(res => {
                                let { retData } = res
                                let max = (retData as any).maxPrice.toFixed(2)
                                let min = (retData as any).minPrice.toFixed(2)
                                setMaxPrice(max)
                                setMinPrice(min)
                            })

                        },

                    };
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
            <div style={{ paddingRight: '50px', display: 'inline-block' }}><span style={{ fontSize: '18px', fontWeight: "bold", color: '#323232' }}>最高售价:</span><span style={{ fontSize: '18px', color: 'red', fontWeight: "bold" }}>{maxPrice}</span></div>
            <div style={{ display: 'inline-block' }}><span style={{ fontSize: '18px', fontWeight: "bold", color: '#323232' }}>最低售价:</span><span style={{ fontSize: '18px', color: 'red', fontWeight: "bold" }}>{minPrice}</span></div>
        </YhBox>

    </YHModal>
}